export default function fancyBox(){
    if(document.querySelector(".enterprise-gallery__slider")){
        let slides = document.querySelectorAll(".enterprise-gallery__slider .swiper-slide");

        slides.forEach(slide => {
            Fancybox.bind(`[data-fancybox='${slide.attributes[1].textContent}']`, {
                Thumbs: {
                    type: "classic",
                },
            });
        });
    }

    if (document.querySelector(".enterprise-plans")) {
        let plans = document.querySelectorAll(".enterprise-plans .enterprise-plans__item");

        plans.forEach(plan => {
            Fancybox.bind(`[data-fancybox='${plan.attributes[1].textContent}']`, {
                Thumbs: {
                    type: "classic",
                },
            });
        });
    }

    Fancybox.bind("[data-fancybox='single-gallery']", {
        Thumbs: {
            type: "classic",
        },
    });

    Fancybox.bind("[data-fancybox='banner-gallery']", {
        Thumbs: {
            type: "classic",
        },
    });
}
